import React from 'react';

export default function FunnelNotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">This funnel is not available</h1>
        <p className="text-gray-500 text-sm">
          The page you are looking for may have been removed or is not yet published.
        </p>
      </div>
    </div>
  );
}
